<template>
    <div class="modal-card card">
        <form @submit.prevent="onFormSubmit()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Renew Certificate</h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="card-body">
                <p>Are you sure you want to renew the following Certificate?</p>
                <ul class="list-group list-group-sm">
                    <li class="list-group-item">
                        {{ modalData.commonName }}
                    </li>
                </ul>
            </div>
            <div class="card-footer text-end">
                <button class="btn btn-primary" :disabled="renewInProgress">
                    <div v-if="renewInProgress" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>
                        Renew
                    </div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            error: "",
            renewInProgress: false
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "DeleteCertificates",
    methods: {
        ...mapActions("aut", {
            renewCertificate: "renewCertificate",
        }),
        async onFormSubmit() {
            this.renewInProgress = true;
            let toastOptions = {
                message: "Certificate renewed successfully.",
                type: "success"
            }
            try {
                await this.renewCertificate({commonName: this.modalData.commonName, payload: {}})
            } catch (error) {
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                toastOptions = {
                    message: error || "Something went wrong while renewing certificates. Please contact support.",
                    type: "error"
                }
                return;
            } finally {
                this.renewInProgress = false;
                this.$store.dispatch("addToast", toastOptions);
            }
            this.$store.dispatch("hideModal");
            this.$store.state.aut.renewCertTrigger = !this.$store.state.aut.renewCertTrigger;
        },
    },
};
</script>

<style></style>